// ─────────────────────────────────────────────────────────────────────────────
// deltaCallGate.ts — THE ONE POST. `POST /api/delta/call-gate`.
//
// The body is built and checked in `lib/deltaCallGate`; this file only sends it
// and reads the answer. Bearer from `authToken()`, the same carrier every Delta
// client uses (APP_CALLS_CONTRACT §0 — the header is the only one accepted).
//
// ── A LOST ANSWER IS NOT A REFUSAL ─────────────────────────────────────────
// When the request throws, the server may or may not have written. The gate
// says there was no answer and the list — re-read — shows what landed; it never
// claims the answer failed to land.
// ─────────────────────────────────────────────────────────────────────────────

import { apiBase, authToken } from './apiBase';
import { CallGateBody, CallGateResult, readCallGateResponse } from '../lib/deltaCallGate';

export const DELTA_CALL_GATE_PATH = '/delta/call-gate';

export async function postCallGate(body: CallGateBody): Promise<CallGateResult> {
  let res: Response;
  try {
    res = await fetch(apiBase() + DELTA_CALL_GATE_PATH, {
      method: 'POST',
      headers: { Authorization: 'Bearer ' + authToken(), 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });
  } catch {
    return { phase: 'failed', error: 'no answer from the server' };
  }
  let json: unknown = null;
  try {
    json = await res.json();
  } catch {
    json = null;
  }
  return readCallGateResponse(res.status, json);
}
